import { render, staticRenderFns } from "./titleBar.vue?vue&type=template&id=c5eb351a&scoped=true"
import script from "./titleBar.vue?vue&type=script&lang=js"
export * from "./titleBar.vue?vue&type=script&lang=js"
import style0 from "./titleBar.vue?vue&type=style&index=0&id=c5eb351a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eb351a",
  null
  
)

export default component.exports